import { render, staticRenderFns } from "./FeedbackSettingForm.vue?vue&type=template&id=0abacffa&scoped=true&"
import script from "./FeedbackSettingForm.vue?vue&type=script&lang=ts&"
export * from "./FeedbackSettingForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abacffa",
  null
  
)

export default component.exports